import React from 'react';
import FrontHeader from '../components/common/FrontHeader';
import FrontFooter from '../components/common/FrontFooter';
import './LegalPages.css';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <FrontHeader />
      <div className="legal-container">
        <h1>Terms of Service</h1>
        <p className="last-updated">Effective date: June 08, 2026</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing or using SeaZex, you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree, please do not use the platform.</p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>SeaZex is a maritime service marketplace connecting ship owners with verified service providers. Owners may post job requests (RFQs), and providers may submit quotations. Payments are processed via secure escrow.</p>
        </section>

        <section>
          <h2>3. User Accounts</h2>
          <p>You must be at least 18 years old and a legal entity to register. You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account.</p>
        </section>

        <section>
          <h2>4. Service Provider Verification</h2>
          <p>Service providers must submit accurate company information and certifications. SeaZex reserves the right to verify or reject any provider. Verified status indicates that documents have been reviewed but does not guarantee work quality.</p>
        </section>

        <section>
          <h2>5. Escrow and Payments</h2>
          <p>When a quotation is accepted, the owner must deposit the full amount into escrow. Funds are held securely and released to the provider only after the owner confirms work completion. SeaZex charges a 10% platform fee on the quotation amount, deducted from the provider's payment.</p>
        </section>

        <section>
          <h2>6. Disputes</h2>
          <p>If a dispute arises, both parties agree to communicate through the platform's dispute resolution system. SeaZex may review evidence and make a binding decision, including releasing or refunding escrowed funds.</p>
        </section>

        <section>
          <h2>7. Prohibited Conduct</h2>
          <p>You may not post fraudulent jobs, submit fake quotations, attempt to bypass escrow payments, harass other users, or violate any applicable laws. Violations may result in account suspension or termination.</p>
        </section>

        <section>
          <h2>8. Limitation of Liability</h2>
          <p>SeaZex is not liable for any indirect, incidental, or consequential damages arising from use of the platform. Our total liability is limited to the fees paid by you in the preceding 12 months.</p>
        </section>

        <section>
          <h2>9. Modifications</h2>
          <p>We may modify these terms at any time. Continued use of the platform after changes constitutes acceptance of the new terms.</p>
        </section>

        <section>
          <h2>10. Governing Law</h2>
          <p>These terms are governed by the laws of Dubai, United Arab Emirates. Any disputes shall be resolved in the courts of Dubai.</p>
        </section>
      </div>
      <FrontFooter />
    </div>
  );
};

export default TermsOfService;